import styled from "@emotion/styled";
import { fontBarlowSemiCondensed, fontPlayfairDisplay } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";
import { TopicLink } from "~/components/topic/topic-link";

export const StyledEntityLink = styled(EntityLink)`
  color: #222222;
`;

export const Topic = styled(TopicLink)`
  margin-block-start: 8px;

  color: #222222;
  font-weight: 500;
  font-family: ${fontBarlowSemiCondensed};
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;
export const Cover = styled.div``;
export const Headline = styled.div`
  font-weight: 400;
  font-size: 32px;
  font-family: ${fontPlayfairDisplay};
  line-height: 38px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 400px;
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    text-align: center;
  }
`;
